import type { PlatformDictionary } from '../types';

export const ruDictionary: PlatformDictionary = {
  languageName: 'Russian',
  languageNativeName: 'Русский',
  layout: {
    defaultMetaTitle: 'Услуги, профили и инсайты',
    defaultMetaDescription:
      'Находите проверенных специалистов, сравнивайте услуги и читайте практичные материалы в блоге Matcha Events.',
    builtWith: 'Работает на Next.js, TypeORM, PostgreSQL и Strapi.',
    headerStatsProfilesValue: 'Профили',
    headerStatsProfilesTitle: 'Проверенные исполнители',
    headerStatsProfilesDescription:
      'Подбирайте специалистов по экспертизе, локации и доступности до первого контакта.',
    headerStatsServicesValue: 'Услуги',
    headerStatsServicesTitle: 'Активные предложения',
    headerStatsServicesDescription:
      'Сравнивайте объём работ и модели ценообразования, чтобы быстрее выбрать подходящий вариант.',
    headerStatsInsightsValue: 'Инсайты',
    headerStatsInsightsTitle: 'Практические гайды',
    headerStatsInsightsDescription:
      'Читайте свежие материалы блога, чтобы планировать работу и избегать типичных ошибок.',
    footerDescription: 'Находите исполнителей, услуги и практические материалы в одном месте.',
    footerColumnPlatform: 'Платформа',
    footerColumnResources: 'Ресурсы',
    footerColumnLegal: 'Правовая информация',
    footerFaq: 'FAQ',
    footerTerms: 'Условия и положения',
    footerPrivacy: 'Политика конфиденциальности',
  },
  localeSwitcher: {
    label: 'Язык',
  },
  nav: {
    profiles: 'Профили',
    services: 'Услуги',
    admin: 'Админ',
    blog: 'Блог',
    chat: 'Чат',
  },
  auth: {
    openAccountMenu: 'Открыть меню аккаунта',
    openSupport: 'Открыть поддержку',
    supportTooltip: 'Открыть страницу поддержки',
    accountMenu: 'Меню аккаунта',
    signedIn: 'Вы вошли',
    notSignedIn: 'Вы не вошли',
    switchAccount: 'Сменить аккаунт',
    signOut: 'Выйти',
    signIn: 'Войти',
    signUp: 'Зарегистрироваться',
    createAccount: 'Создать аккаунт',
    subtitle: 'Войдите, чтобы получить доступ к защищённым функциям платформы.',
    closeDialog: 'Закрыть диалог аутентификации',
    closeButton: 'Закрыть',
    modeLabel: 'Режим аутентификации',
    firstName: 'Имя',
    lastName: 'Фамилия',
    identifier: 'Email или номер телефона',
    identifierPlaceholder: 'name@example.com или +380501234567',
    identifierHint: 'Используйте email или телефон в международном формате.',
    identifierInvalid: 'Введите корректный email или номер телефона.',
    password: 'Пароль',
    passwordHintSignIn: 'Введите пароль вашего аккаунта.',
    passwordHintSignUp: 'Минимум 8 символов, хотя бы одна буква и одна цифра.',
    passwordTooShort: 'Пароль должен содержать не менее 8 символов.',
    passwordNeedsLetterAndNumber: 'Пароль должен содержать хотя бы одну букву и одну цифру.',
    submitWaiting: 'Пожалуйста, подождите...',
    authFailed: 'Не удалось завершить аутентификацию.',
    missingToken: 'Аутентификация прошла успешно, но токен доступа не был получен.',
    appleCredentialMissing: 'Вход через Apple не вернул ID токен.',
    appleLoadFailed: 'Не удалось загрузить вход через Apple. Попробуйте позже.',
    continueWithApple: 'Продолжить с Apple',
    googleCredentialMissing: 'Вход через Google не вернул ID токен.',
    googleLoadFailed: 'Не удалось загрузить вход через Google. Попробуйте позже.',
    continueWithGoogle: 'Продолжить с Google',
  },
  authPage: {
    heroTitle: 'Добро пожаловать',
    heroDescription: 'Используйте эти формы, чтобы войти или создать новый аккаунт.',
    signInHeading: 'Войти',
    signInMissingFields: 'Требуются email/номер телефона и пароль.',
    signInSubmit: 'Войти',
    signInSubmitting: 'Вход...',
    signInFailed: 'Не удалось войти. Попробуйте ещё раз.',
    tooManyAttempts: 'Слишком много попыток. Попробуйте снова через {minutes} мин.',
    signUpHeading: 'Создать аккаунт',
    signUpMissingFields: 'Требуются имя, фамилия, email/номер телефона и пароль.',
    signUpSubmit: 'Зарегистрироваться',
    signUpSubmitting: 'Регистрация...',
    signUpFailed: 'Не удалось зарегистрироваться. Попробуйте ещё раз.',
    rememberMe: 'Запомнить меня',
    alreadyHaveAccount: 'Уже есть аккаунт?',
    noAccountYet: 'Ещё нет аккаунта?',
    agreePrefix: 'Я принимаю',
    termsAndConditions: 'Условия и положения',
    acceptTermsRequired: 'Необходимо принять условия и положения.',
    orDivider: 'или',
    cookieNotice:
      'Мы используем cookie, чтобы сохранять вход, запоминать ваши настройки и улучшать работу админ-панели Matcha Events. Подробнее в',
  },
  common: {
    draft: 'Черновик',
    noExcerpt: 'Краткое описание пока недоступно.',
    pricingOnRequest: 'Цена по запросу',
    from: 'От',
    per: 'За',
    marketplacePlatform: 'Маркетплейс-платформа',
    marketplaceProfiles: 'Профили маркетплейса',
    marketplaceServices: 'Услуги маркетплейса',
    clearFilter: 'Сбросить фильтр',
    backToHome: 'Назад на главную',
    posted: 'Опубликовано',
    published: 'Опубликовано',
    listedBy: 'Размещено',
    noContent: 'Контент недоступен.',
    loading: 'Загрузка...',
    pagination: 'Пагинация',
    previous: 'Предыдущая',
    next: 'Следующая',
    first: 'Первая',
    last: 'Последняя',
  },
  adminChrome: {
    homeBreadcrumb: 'Главная',
    dashboardBreadcrumb: 'Дашборд',
    eventsBreadcrumb: 'События',
    messagesBreadcrumb: 'Сообщения',
    servicesBreadcrumb: 'Услуги',
    positionsBreadcrumb: 'Позиции',
    accountFallback: 'Аккаунт',
    profileFallback: 'Профиль',
    serviceFallback: 'Услуга',
    manageProfile: 'Управлять профилем',
    profilesLabel: 'Профили',
    profilesLoading: 'Загрузка профилей...',
    profilesEmpty: 'Профили недоступны.',
    addProfile: 'Добавить профиль',
    createProfileDialogTitle: 'Добавить профиль',
    createProfileTitlePlaceholder: 'Название профиля',
    createProfileDescriptionPlaceholder: 'Описание (необязательно)',
    createProfileValidation: 'Название профиля должно содержать не менее 2 символов.',
    createProfileAccountMissing: 'Не удалось определить аккаунт для создания профиля.',
    createProfileSubmit: 'Добавить профиль',
    createProfileSubmitting: 'Создание профиля...',
    tableEntriesPerPage: 'записей на странице',
    tableSearchPlaceholder: 'Поиск...',
    tableShowingEntries: 'Показано с {start} по {end} из {total} записей',
    footerMadeWith: 'сделано с',
    footerBy: 'от',
    footerForBetterEvents: 'для лучших событий',
    appDownloadBanner: 'Приложение Matcha Events доступно для скачивания',
    appDownloadAppStore: 'App Store',
    appDownloadAppStoreCta: 'Скачать в App Store',
    appDownloadGooglePlay: 'Google Play',
    appDownloadGooglePlayCta: 'Доступно в Google Play',
    summerPromoDismiss: 'Закрыть баннер',
    cancel: 'Отмена',
  },
  createProfilePage: {
    heading: 'Создайте свой профиль',
    description: 'Создайте хотя бы один профиль, чтобы публиковать услуги и управлять ими.',
    titlePlaceholder: 'Название профиля',
    descriptionPlaceholder: 'Описание (необязательно)',
    submit: 'Создать профиль',
    submitting: 'Создание профиля...',
    titleValidation: 'Название профиля должно содержать не менее 2 символов.',
    createFailed: 'Не удалось создать профиль. Попробуйте ещё раз.',
  },
  adminInputs: {
    searchCategoriesPlaceholder: 'Поиск категорий',
    searchCategoriesHelper: 'Введите название категории и нажмите Enter',
    searchSkillsPlaceholder: 'Поиск навыков',
    searchSkillsHelper: 'Ищите существующие навыки или введите новый и нажмите Enter',
    searchExclusionsPlaceholder: 'Добавить вид работы',
    searchExclusionsHelper: 'Выберите навык или введите собственную формулировку (до 60 символов) и нажмите Enter',
    relatedSkillsLoading: 'Загрузка навыков для выбранных категорий...',
    relatedSkillsTitle: 'Навыки из выбранных категорий',
    searchLanguagesPlaceholder: 'Поиск языков',
    searchLanguagesHelper: 'Введите название языка и нажмите Enter',
    searchCityPlaceholder: 'Поиск города',
    cityHelperDefault: 'Выберите город из списка или начните вводить для поиска.',
    cityHelperNoApi: 'Выберите город из списка или введите его и нажмите Enter, чтобы добавить.',
    cityHelperUnavailable: 'Выберите город из списка. Google autocomplete сейчас недоступен.',
    googleFallbackDisabled:
      'Google autocomplete отключён. Укажите REACT_APP_GOOGLE_MAPS_API_KEY, чтобы включить подсказки.',
    googleFallbackUnavailable:
      'Google autocomplete сейчас недоступен. Вы всё равно можете вводить значение вручную.',
  },
  adminProfileEditor: {
    unavailable: 'Детали профиля недоступны.',
    slugTaken: 'Этот slug профиля уже занят. Выберите другой.',
    firstNameLabel: 'Имя',
    firstNamePlaceholder: 'Имя',
    lastNameLabel: 'Фамилия',
    lastNamePlaceholder: 'Фамилия',
    titleLabel: 'Название',
    titlePlaceholder: 'Название профиля',
    descriptionLabel: 'Описание',
    descriptionPlaceholder: 'Описание профиля',
    categoriesLabel: 'Категории',
    skillsLabel: 'Навыки',
    exclusionsLabel: 'Не рассматриваю',
    exclusionInvalid: 'Пункт должен содержать до 60 символов, без ссылок, упоминаний и номеров телефона.',
    exclusionSkillConflict: 'Навык не может быть одновременно среди навыков и в «Не рассматриваю». Уберите его из одного из списков.',
    slugLabel: 'Slug профиля',
    slugTooltip: 'Публичный URL: /profiles/{slug}',
    slugPlaceholder: 'your-profile-slug',
    citiesLabel: 'Города',
    coverageRadiusLabel: 'Радиус покрытия (км)',
    coverageRadiusPlaceholder: '50',
    languagesLabel: 'Языки',
    contactsLabel: 'Контакты',
    addContact: 'Добавить контакт',
    noContacts: 'Контактов пока нет. Добавьте один или несколько контактов профиля.',
    contactEmailPlaceholder: 'name@example.com',
    contactPhonePlaceholder: '+7 999 123 45 67',
    contactDetailsPlaceholder: 'Контактные данные',
    socialLinksLabel: 'Соцсети',
    addLink: 'Добавить ссылку',
    noLinks: 'Ссылок пока нет. Добавьте одну или несколько ссылок профиля.',
    socialLinkPlaceholder: 'https://social-link.example',
    uploadAvatar: 'Загрузить аватар',
    uploadingAvatar: 'Загрузка...',
    saveChanges: 'Сохранить изменения',
    saving: 'Сохранение...',
    deleteAction: 'Удалить',
    avatarUploadSizeLimit: 'Файл должен быть не больше 50 МБ.',
    avatarUploaded: 'Аватар загружен.',
    avatarFileType: 'Файл аватара должен быть изображением.',
    avatarMismatch: 'Загруженный аватар не соответствует активному профилю.',
    avatarUploadFailed: 'Не удалось загрузить аватар. Попробуйте ещё раз.',
    contactMissingValue: 'В каждой строке контакта должно быть значение.',
    contactUniqueType: 'Каждый тип контакта можно использовать только один раз.',
    socialMissingUrl: 'В каждой строке социальной ссылки должен быть URL.',
    socialUniquePlatform: 'Каждую социальную платформу можно использовать только один раз.',
    cityMissingValue: 'В каждой строке города должно быть указано значение города.',
    cityPlaceIdMissing:
      'Выбирайте каждый город из подсказок, чтобы он содержал корректный place ID.',
    cityDuplicate: 'Дубли городов не допускаются.',
    titleValidation: 'Название профиля должно содержать не менее 2 символов.',
    coverageRadiusValidation: 'Радиус покрытия должен быть целым числом от 0 до 1000 км.',
    slugMin: 'Slug профиля должен содержать не менее 3 символов.',
    slugMax: 'Slug профиля должен содержать не более 128 символов.',
    profileUpdated: 'Профиль обновлён.',
    profileUuidMissing: 'UUID профиля отсутствует.',
    profileNotFound: 'Профиль не найден.',
    profileLoadFailed: 'Не удалось загрузить детали профиля.',
    profileUpdateFailed: 'Не удалось обновить профиль. Попробуйте ещё раз.',
    loadingProfile: 'Загрузка профиля...',
    profileCardFallbackTitle: 'Профиль',
    profileCardFallbackSubtitle: 'Профиль услуги',
    profileAvatarAlt: 'Аватар профиля',
  },
  adminServiceEditor: {
    createTitle: 'Создать услугу',
    updateTitle: 'Обновить услугу',
    updateDescription: 'Редактируйте детали услуги на отдельной странице.',
    loading: 'Загрузка услуги...',
    notFound: 'Услуга не найдена.',
    loadFailed: 'Не удалось загрузить услугу. Попробуйте ещё раз.',
    titleLabel: 'Название',
    titlePlaceholder: 'Название услуги',
    slugLabel: 'Slug услуги',
    slugTooltip:
      'Slug - это публичная часть URL этой услуги (последний сегмент в /profiles/{profileSlug}/services/{serviceSlug}). Используйте строчные буквы, цифры и дефисы.',
    slugPlaceholder: 'Slug услуги (необязательно)',
    descriptionLabel: 'Описание',
    descriptionPlaceholder: 'Полное описание для страницы услуги (800-1200 слов)',
    shortDescriptionLabel: 'Короткое описание',
    shortDescriptionPlaceholder: 'Короткое описание для карточки услуги (20-40 слов)',
    seoDescriptionLabel: 'SEO-описание',
    seoDescriptionPlaceholder: 'SEO-описание (150-160 символов)',
    pricingModeLabel: 'Модель цены',
    currencyLabel: 'Валюта',
    pricingModeFixed: 'Фиксированная',
    pricingModeFrom: 'От',
    pricingModeRange: 'Диапазон (мин/макс)',
    priceLabel: 'Цена',
    fromPriceLabel: 'Цена от',
    minimumPriceLabel: 'Минимальная цена',
    pricePlaceholder: 'Цена',
    fromPricePlaceholder: 'Начиная от',
    minimumPricePlaceholder: 'Минимальная цена',
    maximumPriceLabel: 'Максимальная цена',
    maximumPricePlaceholder: 'Максимальная цена',
    unitLabel: 'Единица (необязательно)',
    unitNone: 'Нет',
    unitHour: 'За час',
    unitDay: 'За день',
    unitWeek: 'За неделю',
    unitMonth: 'За месяц',
    unitSession: 'За сессию',
    unitItem: 'За единицу',
    unitCustom: 'Своя',
    customUnitPlaceholder: 'Своя единица (например, за м2)',
    mediaLabel: 'Медиа',
    addMediaEmpty: 'Добавьте медиа к этой услуге.',
    addMediaAction: 'Добавить медиа',
    rehostFromLink: 'Перенести по ссылке',
    removeMediaAria: 'Удалить медиа',
    altTextPlaceholder: 'Alt-текст',
    altTextAria: 'Alt-текст для {fileName}',
    addMediaDialogTitle: 'Добавить медиа',
    mediaSourceLabel: 'Источник',
    mediaSourceFiles: 'Загрузить файлы',
    mediaSourceUrl: 'Перенести по ссылке',
    mediaUrlPlaceholder: 'https://youtube.com/watch?v=...',
    mediaUrlHelper: 'Вставьте URL медиа, чтобы загрузить его и сохранить в вашем хранилище.',
    mediaTypeUrlLabel: 'Тип медиа (необязательно)',
    mediaTypeFallbackLabel: 'Тип медиа для неопределённых файлов',
    mediaTypePlaceholder: 'Выберите тип медиа',
    mediaTypeImage: 'Изображение',
    mediaTypeVideo: 'Видео',
    mediaTypeMusic: 'Музыка',
    mediaTypeFile: 'Файл',
    selectedUrlTemplate: 'Выбранный URL: {value}',
    selectedUrlEmpty: 'Укажите URL медиа для переноса.',
    selectedFileTemplate: 'Выбранный файл: {value}',
    selectedFilesTemplate: 'Выбрано файлов: {count}',
    detectedMediaTypeTemplate: 'Определён тип медиа: {types}.',
    detectedMediaTypesTemplate: 'Определены типы медиа: {types}.',
    undetectedMediaFileTemplate: 'Не удалось определить тип медиа для 1 файла.',
    undetectedMediaFilesTemplate: 'Не удалось определить тип медиа для {count} файлов.',
    addMediaSubmit: 'Добавить медиа',
    addMediaSubmitting: 'Добавление...',
    rehostMediaSubmit: 'Перенести медиа',
    rehostMediaSubmitting: 'Перенос...',
    mediaDeleteDialogTitle: 'Удалить медиа',
    mediaDeleteDialogDescription:
      'Вы уверены, что хотите удалить {title}? Это действие нельзя отменить.',
    mediaDeleteDialogFallbackTitle: 'этот медиафайл',
    mediaDeleteDialogConfirm: 'Удалить',
    mediaDeleteInProgress: 'Удаление...',
    saveChanges: 'Сохранить изменения',
    saving: 'Сохранение...',
    cancel: 'Отмена',
    createSubmit: 'Создать',
    createSubmitting: 'Создание...',
    titleValidation: 'Название услуги должно содержать не менее 2 символов.',
    slugMin: 'Slug услуги должен содержать не менее 3 символов.',
    slugMax: 'Slug услуги должен содержать не более 128 символов.',
    shortDescriptionMax: 'Короткое описание должно содержать не более 280 символов.',
    seoDescriptionMax: 'SEO-описание должно содержать не более 320 символов.',
    priceValidation: '{label} должно быть корректным числом не меньше 0.',
    maximumPriceValidation: 'Максимальная цена должна быть корректным числом не меньше 0.',
    maximumPriceRangeValidation: 'Максимальная цена должна быть больше или равна минимальной цене.',
    customUnitRequired: 'Своя единица обязательна, когда выбран пользовательский тип единицы.',
    customUnitInvalid:
      'Свою единицу можно указать только при выборе пользовательского типа единицы.',
    createFailed: 'Не удалось создать услугу. Попробуйте ещё раз.',
    updateFailed: 'Не удалось обновить услугу. Попробуйте ещё раз.',
    slugTaken: 'Этот slug услуги уже занят. Выберите другой.',
    mediaUploadSizeLimit: 'Каждый загруженный файл должен быть не больше 1 ГБ.',
    serviceIdentifierMissing: 'Идентификатор услуги отсутствует.',
    mediaUrlRequired: 'URL медиа обязателен.',
    mediaFilesRequired: 'Нужно выбрать хотя бы один файл.',
    mediaTypeRequired: 'Тип медиа обязателен, если автоматическое определение не сработало.',
    deleteAction: 'Удалить услугу',
    deleteDialogTitle: 'Удалить услугу',
    deleteDialogDescription:
      'Вы уверены, что хотите удалить {title}? Это действие нельзя отменить.',
    deleteDialogFallbackTitle: 'эту услугу',
    deleteDialogCancel: 'Отмена',
    deleteDialogConfirm: 'Удалить',
    deleteInProgress: 'Удаление...',
    deleteFailed: 'Не удалось удалить услугу. Попробуйте снова.',
    citiesLabel: 'Города',
    citiesSameAsProfile: 'Как в профиле',
    citiesProfileEmpty: 'В профиле пока нет городов.',
    citiesRequired: 'Добавьте хотя бы один город или включите «Как в профиле».',
    citiesResetDialogTitle: 'Использовать города профиля?',
    citiesResetDialogDescription: 'Собственные города услуги будут удалены.',
    citiesResetDialogConfirm: 'Удалить города',
  },
  home: {
    title: 'Главная',
    description:
      'Находите узкопрофильных исполнителей, сравнивайте предложения и следите за обновлениями платформы Matcha Events.',
    heroTitle: 'Найдите команду для мероприятия, которую вы полюбите.',
    heroDescription:
      'Просматривайте организаторов мероприятий и специалистов, сравнивайте услуги и бронируйте с уверенностью.',
    ctaBrowseProfiles: 'Смотреть профили',
    ctaBrowseServices: 'Смотреть услуги',
    ctaReadBlog: 'Читать блог',
    featuredProfiles: 'Рекомендуемые профили',
    viewAll: 'Смотреть все',
    noProfiles:
      'Профили пока недоступны. Добавьте данные в таблицы PostgreSQL `profiles` и `services`, чтобы заполнить этот раздел.',
    servicesCount: 'услуг',
    fromBlog: 'Из блога',
    seeAllPosts: 'Все посты',
    noPostsConfigured:
      'Посты блога появятся здесь после настройки `STRAPI_BASE_URL` и публикации записей в Strapi.',
    noPostsYet:
      'Strapi пока не вернул посты. Опубликуйте контент в настроенной коллекции, чтобы заполнить этот раздел.',
    discoverNaturalLabel: 'Опишите, что вам нужно',
    discoverFormTitle: 'Кого вы ищете?',
    discoverNaturalPlaceholder:
      'Нужен свадебный фотограф в вашем районе до $500 с опытом съёмки мероприятий.',
    discoverNaturalExamples: [
      'Нужен свадебный фотограф в вашем районе до $500 с опытом съёмки мероприятий.',
      'Ищу флориста для гала на 200 гостей.',
      'Найдите звукорежиссёра для двухдневной конференции.',
    ],
    discoverNaturalSubmit: 'Найти варианты',
    discoverFiltersLabel: 'Уточните фильтры',
    discoverQueryLabel: 'Поисковый запрос',
    discoverLocationLabel: 'Локация',
    discoverBudgetMinLabel: 'Мин. бюджет',
    discoverBudgetMaxLabel: 'Макс. бюджет',
    discoverCurrencyLabel: 'Валюта',
    discoverCurrencyAny: 'Любая валюта',
    discoverCategoriesLabel: 'Категории',
    discoverCategoryAny: 'Любая категория',
    discoverCategoryPlaceholder: 'Найдите и добавьте категории',
    discoverSkillsLabel: 'Навыки',
    discoverSkillPlaceholder: 'Найдите и добавьте навыки',
    discoverAddSkill: 'Добавить',
    discoverApplyFilters: 'Применить фильтры',
    discoverSuggestedSkills: 'Рекомендуемые навыки',
    discoverProfilesResults: 'Подходящие профили',
    discoverServicesResults: 'Подходящие услуги',
    discoverNoResults: 'По текущим фильтрам совпадений не найдено.',
    discoverSearching: 'Поиск...',
    discoverSkillLoading: 'Загрузка навыков...',
    discoverSearchFailed: 'Не удалось выполнить поиск. Попробуйте снова.',
  },
  servicesPage: {
    navLabel: 'Мои услуги',
    title: 'Услуги',
    description: 'Просматривайте активные услуги с прозрачными ценами и контекстом исполнителей.',
    heroTitle: 'Просматривайте активные услуги',
    heroDescription:
      'Каждая услуга объединяет ценовую модель сущности service и профиль исполнителя, используя карточки текущего дизайна платформы.',
    noServices:
      'Активные услуги не найдены. Убедитесь, что в таблице `services` есть строки с `deleted_at IS NULL`.',
    priceModeFrom: 'От',
    priceModeRange: 'Диапазон',
    priceModeFixed: 'Фиксировано',
    viewDetails: 'Подробнее',
    adminListDescription: 'Услуги, созданные в активном профиле.',
    adminCreateAction: 'Создать услугу',
    adminSearchPlaceholder: 'Поиск услуг',
    adminCountSummary: '{visible} из {total} услуг',
    adminLoading: 'Загрузка услуг...',
    adminEmpty: 'Услуг пока нет.',
    adminEmptySearch: 'По вашему запросу услуги не найдены.',
    adminAccountMissing: 'Аккаунт не найден. Войдите снова.',
    adminProfileMissing: 'Профили не найдены. Сначала создайте профиль.',
    adminEditAction: 'Редактировать услугу',
    adminSlugPending: 'Slug будет сгенерирован',
    adminLoadFailed: 'Не удалось загрузить услуги. Попробуйте ещё раз.',
  },
  eventsPage: {
    navLabel: 'События',
    title: 'События',
    listDescription: 'События, созданные в вашем аккаунте, с временем начала и окончания.',
    createAction: 'Создать событие',
    accountMissing: 'Аккаунт не найден. Войдите снова.',
    loadFailed: 'Не удалось загрузить события. Попробуйте ещё раз.',
    loading: 'Загрузка событий...',
    empty: 'Событий пока нет.',
    createDialogTitle: 'Создать событие',
    createSubmit: 'Создать',
    createSubmitting: 'Создание...',
    createFailed: 'Не удалось создать событие. Попробуйте ещё раз.',
    notFound: 'Событие не найдено.',
    updateTitle: 'Обновить событие',
    updateDescription: 'Редактируйте детали события на отдельной странице.',
    updateFailed: 'Не удалось обновить событие. Попробуйте ещё раз.',
    loadingSingle: 'Загрузка события...',
    saveChanges: 'Сохранить изменения',
    saving: 'Сохранение...',
    cancel: 'Отмена',
    titlePlaceholder: 'Название события',
    descriptionPlaceholder: 'Описание (необязательно)',
    cityPlaceholder: 'Город (необязательно)',
    cityHelper: 'Начните вводить город и выберите его из подсказок Google.',
    locationPlaceholder: 'Локация / площадка (необязательно)',
    locationHelper: 'Ищите подсказки площадки или адреса в выбранном регионе.',
    selectCityFirst: 'Сначала выберите город, чтобы указать детали локации.',
    tableEvent: 'событие',
    tableCityLocation: 'город / локация',
    tableStarts: 'начало',
    tableEnds: 'окончание',
    tableDescription: 'описание',
    cityLabel: 'Город',
    locationLabel: 'Локация',
    notSpecified: 'Не указано',
    noDescription: 'Без описания',
    unknownDate: 'Неизвестно',
    positionsTitle: 'Позиции события',
    positionsDescription: 'Создавайте кадровые позиции, привязанные к этому событию.',
    requestPosition: 'Запросить позицию',
    positionsLoading: 'Загрузка позиций...',
    positionsLoadFailed: 'Не удалось загрузить позиции для этого события. Попробуйте ещё раз.',
    positionsEmpty: 'К этому событию пока не привязано позиций.',
    validationAccountMissing: 'Аккаунт не найден. Войдите снова и попробуйте ещё раз.',
    validationTitleMin: 'Название события должно содержать не менее 2 символов.',
    validationDescriptionMax: 'Описание должно содержать не более 2000 символов.',
    validationCityMax: 'Название города должно содержать не более 512 символов.',
    validationLocationMax: 'Локация должна содержать не более 255 символов.',
    validationStartInvalid: 'Время начала должно быть корректной датой и временем.',
    validationEndInvalid: 'Время окончания должно быть корректной датой и временем.',
    validationEndAfterStart: 'Время окончания должно быть позже времени начала.',
  },
  positionsPage: {
    navLabel: 'Позиции',
    editTitle: 'Обновить позицию',
    editDescription: 'Редактируйте детали позиции и управляйте статусом публикации.',
    loading: 'Загрузка позиции...',
    notFound: 'Позиция не найдена.',
    loadFailed: 'Не удалось загрузить позицию. Попробуйте ещё раз.',
    updateFailed: 'Не удалось обновить позицию. Попробуйте ещё раз.',
    statusLabel: 'Статус',
    titlePlaceholder: 'Название позиции',
    descriptionPlaceholder: 'Описание (необязательно)',
    locationPlaceholder: 'Локация (необязательно)',
    budgetCurrencyLabel: 'Валюта бюджета',
    budgetMinPlaceholder: 'Минимальный бюджет (необязательно)',
    budgetMaxPlaceholder: 'Максимальный бюджет (необязательно)',
    saveChanges: 'Сохранить изменения',
    saving: 'Сохранение...',
    cancel: 'Отмена',
    publish: 'Опубликовать',
    publishing: 'Публикация...',
    publishedSuccess: 'Позиция опубликована.',
    publishFailed: 'Не удалось опубликовать позицию. Попробуйте ещё раз.',
    close: 'Закрыть',
    closing: 'Закрытие...',
    closeFailed: 'Не удалось закрыть позицию. Попробуйте ещё раз.',
    delete: 'Удалить',
    deleting: 'Удаление...',
    deleteConfirm: 'Удалить эту позицию? Это действие нельзя отменить.',
    deleteFailed: 'Не удалось удалить позицию. Попробуйте ещё раз.',
    requestDialogTitle: 'Запросить позицию',
    requestSubmit: 'Запросить',
    requestSubmitting: 'Создание...',
    requestFailed: 'Не удалось создать позицию. Попробуйте ещё раз.',
    tablePosition: 'позиция',
    tableStatus: 'статус',
    tableBudget: 'бюджет',
    tableSchedule: 'график',
    tableSkills: 'навыки',
    noBudget: 'Без бюджета',
    budgetFrom: 'От {value}',
    budgetUpTo: 'До {value}',
    flexibleSchedule: 'Гибко',
    noSkills: 'Без навыков',
    validationEventMissing: 'Событие не найдено. Перезагрузите страницу и попробуйте ещё раз.',
    validationAccountMissing: 'Аккаунт не найден. Войдите снова и попробуйте ещё раз.',
    validationTitleMin: 'Название позиции должно содержать не менее 2 символов.',
    validationDescriptionMax: 'Описание должно содержать не более 2000 символов.',
    validationLocationMax: 'Локация должна содержать не более 128 символов.',
    validationBudgetMin: 'Минимальный бюджет должен быть числом не меньше 0.',
    validationBudgetMax: 'Максимальный бюджет должен быть числом не меньше 0.',
    validationBudgetMinRequired: 'Минимальный бюджет обязателен, если указан максимальный бюджет.',
    validationBudgetRange: 'Максимальный бюджет должен быть больше или равен минимальному бюджету.',
    validationScheduleTogether: 'Время начала и окончания нужно указывать вместе.',
    validationStartInvalid: 'Время начала должно быть корректной датой и временем.',
    validationEndInvalid: 'Время окончания должно быть корректной датой и временем.',
    validationEndAfterStart: 'Время окончания должно быть позже времени начала.',
  },
  proposalsPage: {
    title: 'Предложения',
    navLabel: 'Мои предложения',
    listDescription: 'Отслеживайте активные и архивные предложения для активного профиля.',
    activeLabel: 'Активные',
    archivedLabel: 'Архив',
    invitesFilterLabel: 'Инвайты ({count})',
    discussingFilterLabel: 'Обсуждение ({count})',
    submittedFilterLabel: 'Отправлено ({count})',
    loading: 'Загрузка предложений...',
    loadFailed: 'Не удалось загрузить предложения. Попробуйте снова.',
    empty: 'Предложений пока нет.',
    accountMissing: 'Аккаунт не найден. Войдите снова.',
    profileMissing: 'Активный профиль не найден. Сначала выберите или создайте профиль.',
    serviceSubtitle: 'Предложение отправлено с услугой {serviceTitle}',
    openPositionAction: 'Открыть позицию',
    acceptAction: 'Принять',
    declineAction: 'Отклонить',
    proposedPriceLabel: 'Предложенная цена',
    acceptFailed: 'Не удалось принять предложение. Попробуйте снова.',
    declineFailed: 'Не удалось отклонить предложение. Попробуйте снова.',
    statusApproved: 'Одобрено',
    statusCanceled: 'Отменено',
    statusDeclined: 'Отклонено',
    statusDiscussing: 'Обсуждение',
    statusRejected: 'Отклонено заказчиком',
    statusSubmitted: 'Отправлено',
    statusViewed: 'Просмотрено',
  },
  analyticsPage: {
    navLabel: 'Дашборд',
    title: 'Аналитика',
    description:
      'Просматривайте трафик профиля, активность в matched-поиске и взаимодействия для активного профиля.',
    range7d: '7д',
    range30d: '30д',
    range90d: '90д',
    loading: 'Загрузка аналитики...',
    loadFailed: 'Не удалось загрузить аналитику. Попробуйте еще раз.',
    profileMissing: 'Активный профиль не найден. Сначала выберите или создайте профиль.',
    noData: 'Для этого периода аналитика пока недоступна.',
    uniqueVisitors: 'Уникальные посетители',
    sessions: 'Сессии',
    profileViews: 'Просмотры профиля',
    profileIncomplete: 'Профиль не заполнен',
    contactsIncomplete: 'Контакты не заполнены',
    socialLinksIncomplete: 'Соцсети не заполнены',
    servicesIncomplete: 'Услуги не заполнены',
    servicesListViews: 'Просмотры списка услуг',
    serviceViews: 'Просмотры услуг',
    contactClicks: 'Клики по контактам',
    socialClicks: 'Клики по соцсетям',
    matchedProfileImpressions: 'Показы matched-профилей',
    matchedServiceImpressions: 'Показы matched-услуг',
    matchedProfileClicks: 'Клики по matched-профилям',
    matchedServiceClicks: 'Клики по matched-услугам',
    totalViewsChartTitle: 'Динамика трафика',
    totalViewsChartDescription: 'Суммарные просмотры профиля и услуг за выбранный период.',
    topServicesTitle: 'Топ услуг',
    topCitiesTitle: 'Топ городов посетителей',
    serviceColumn: 'Услуга',
    cityColumn: 'Город',
    viewsColumn: 'Просмотры',
    visitorsColumn: 'Посетители',
    sessionsColumn: 'Сессии',
    matchedClicksColumn: 'Matched клики',
  },
  profilesPage: {
    title: 'Профили',
    description: 'Просматривайте профили исполнителей, бюджеты и активные услуги на Matcha Events.',
    heading: 'Профили',
    filteredByLocation: 'Фильтр по локации:',
    noProfilesForLocation: 'По этому фильтру локации профили не найдены.',
    noProfiles:
      'Профили не получены. Проверьте переменные `TYPEORM_*` и убедитесь, что в выбранной схеме есть данные в profiles и services.',
    activeServices: 'активных услуг',
  },
  blogPage: {
    title: 'Блог',
    description: 'Читайте новости платформы, гайды и практические материалы от Matcha Events.',
    heading: 'Блог',
    missingStrapi:
      'Укажите `STRAPI_BASE_URL` в `apps/platform/.env.local`, чтобы загружать контент блога из Strapi.',
    noPosts:
      'Strapi пока не вернул посты. Опубликуйте контент в настроенной коллекции, чтобы заполнить страницу.',
  },
  blogPostPage: {
    missingTitle: 'Статья не найдена',
    badge: 'Статья блога',
  },
  faqPage: {
    title: 'FAQ',
    description: 'Найдите ответы на частые вопросы о профилях, услугах и процессах платформы.',
    heading: 'Часто задаваемые вопросы',
    missingStrapi:
      'Укажите `STRAPI_BASE_URL` в `apps/platform/.env.local`, чтобы загружать FAQ из Strapi.',
    noItems:
      'Strapi пока не вернул FAQ-записи. Опубликуйте элементы в вашей FAQ-коллекции, чтобы заполнить страницу.',
    noAnswer: 'Ответ пока недоступен.',
  },
  aiPage: {
    title: 'Официальный ChatGPT-ассистент',
    description:
      'Используйте официального ChatGPT-ассистента Matcha Events для аутентифицированной отправки запросов и действий, связанных с аккаунтом.',
    badge: 'Официальный ассистент',
    heading: 'Используйте нашего официального ChatGPT-ассистента',
    paragraph:
      'Для аутентифицированной отправки запросов в чате используйте официального ChatGPT-ассистента Matcha Events. Это основной сценарий для действий, связанных с аккаунтом.',
    openAssistant: 'Открыть официального ChatGPT-ассистента',
    missingAssistantUrl: '`NEXT_PUBLIC_OFFICIAL_GPT_URL` ещё не настроен.',
    quickStart: 'Быстрый старт',
    step1: 'Откройте официальную ссылку ассистента выше.',
    step2: 'Войдите при запросе.',
    step3: 'Отправьте запрос прямо в чате.',
    copyPromptLabel: 'Промпт для копирования:',
    copyPrompt:
      'Открой официального ассистента Matcha Events для аутентифицированной отправки запросов.',
  },
  legalPage: {
    privacyTitle: 'Политика конфиденциальности',
    privacyDescription:
      'Узнайте, как Matcha Events собирает, обрабатывает и защищает персональные данные.',
    termsTitle: 'Условия и положения',
    termsDescription: 'Ознакомьтесь с условиями использования платформы и сервисов Matcha Events.',
    missingStrapi:
      'Укажите `STRAPI_BASE_URL` в `apps/platform/.env.local`, чтобы загружать юридические страницы из Strapi.',
    missingPrivacy:
      'В Strapi не найдена опубликованная страница Privacy Policy. Создайте запись `legal-page` со slug `privacy-policy`.',
    missingTerms:
      'В Strapi не найдена опубликованная страница Terms and Conditions. Создайте запись `legal-page` со slug `terms-and-conditions`.',
  },
  notFoundPage: {
    heading: 'Страница не найдена',
    description: 'Запрошенный ресурс не существует или больше недоступен.',
    backToHome: 'На главную',
  },
  messagesPage: {
    navLabel: 'Сообщения',
    heading: 'Сообщения',
    subtitle: 'Диалоги в вашем аккаунте. Открывайте любой тред и отправляйте ответы.',
    searchPlaceholder: 'Поиск диалогов',
    newChatAction: 'Новый чат',
    startChatTitle: 'Начать чат',
    startChatDescription: 'Введите точное имя пользователя аккаунта, которому хотите написать.',
    usernameLabel: 'Имя пользователя',
    usernamePlaceholder: 'username',
    usernameRequired: 'Введите имя пользователя, чтобы начать чат.',
    startChatConfirm: 'Начать чат',
    startChatSubmitting: 'Создание...',
    emptyTitle: 'Диалогов пока нет',
    emptyDescription: 'Начните прямой чат, введя точное имя пользователя.',
    emptyConversation: 'Выберите диалог, чтобы посмотреть сообщения.',
    noMessages: 'Сообщений пока нет.',
    notFound: 'Диалог не найден.',
    accountMissing: 'Аккаунт не найден. Войдите снова.',
    loadFailed: 'Не удалось загрузить сообщения. Попробуйте еще раз.',
    startChatFailed: 'Не удалось начать чат. Попробуйте еще раз.',
    sendFailed: 'Не удалось отправить сообщение. Попробуйте еще раз.',
    loadingConversations: 'Загрузка диалогов...',
    loadingMessages: 'Загрузка сообщений...',
    messagePlaceholder: 'Напишите сообщение...',
    sendAction: 'Отправить',
    sending: 'Отправка...',
    directConversationSubtitle: '{name}',
    positionConversationSubtitle: 'Чат по позиции с {name}',
    eventConversationSubtitle: 'Чат по событию с {name}',
    unknownParticipant: 'Неизвестный пользователь',
    typeDirect: 'Прямой',
    typePosition: 'Позиция',
    typeEvent: 'Событие',
    createdAtLabel: 'Обновлено {date}',
  },
  galleriesPage: {
    navLabel: 'Галереи',
    title: 'Галереи',
    loading: 'Загружаем галереи...',
    loadFailed: 'Не удалось загрузить галереи. Попробуйте ещё раз.',
    notFound: 'Галерея не найдена. Возможно, её удалили.',
    profileMissing: 'Профиль не найден. Сначала создайте профиль.',
    newGallery: '+ Новая галерея',
    creating: 'Создаём...',
    untitled: 'Галерея без названия',
    noDate: 'Без даты',
    fileCount: {
      one: '{count} файл',
      few: '{count} файла',
      many: '{count} файлов',
      other: '{count} файла',
    },
    status: {
      ACTIVE: 'Активна',
      SELECTION_SENT: 'Выбор отправлен',
      EXPIRED: 'Срок истёк',
    },
    banner: {
      text: {
        one: '♥ «{title}»: гости отправили выбор — {count} файл',
        few: '♥ «{title}»: гости отправили выбор — {count} файла',
        many: '♥ «{title}»: гости отправили выбор — {count} файлов',
        other: '♥ «{title}»: гости отправили выбор — {count} файла',
      },
      view: 'Посмотреть',
      close: 'Закрыть',
    },
    counters: {
      views: 'Просмотры',
      downloads: 'Скачано файлов',
      zips: 'ZIP-архивов',
      favorites: 'Избранных',
      selected: 'Выбрано',
    },
    settingsButton: 'Настройки',
    share: {
      title: 'Поделиться',
      linkLabel: 'Ссылка на галерею',
      noLink: 'Ссылка появится, как только у профиля будет адрес сайта.',
      copyForClient: 'Скопировать для клиента',
      copied: 'Скопировано: вставьте в сообщение клиенту',
      copyFailed: 'Не удалось скопировать. Выделите текст и скопируйте вручную.',
      openAsGuest: 'Открыть как гость',
      reissue: 'Перевыпустить ссылку',
      reissueTitle: 'Перевыпустить ссылку?',
      reissueBody: 'Старая ссылка сразу перестанет работать. Выбор, комментарии и счётчики сохранятся. Новую ссылку нужно будет отправить клиенту.',
      reissueConfirm: 'Перевыпустить',
      reissued: 'Новая ссылка готова',
      password: 'Пароль: {password}',
      passwordHint: 'Отправьте его вместе со ссылкой или отдельно.',
      noPassword: 'Без пароля: галерею откроет любой, у кого есть ссылка.',
      newPassword: 'Новый пароль',
      newPasswordDone: 'Новый пароль готов: отправьте его клиенту',
      linkTemplate: '{title}: {link}',
      passwordTemplate: 'Пароль: {password}',
    },
    files: {
      allFiles: 'Все файлы',
      selectionTab: '♥ Выбор ({count})',
      sectionUnnamed: 'Раздел без названия',
      sectionsLabel: 'Разделы',
      addSectionPlaceholder: 'Новый раздел',
      addSection: '+ Раздел',
      renameSection: 'Переименовать',
      renameSectionTitle: 'Переименовать раздел',
      sectionNameLabel: 'Название раздела',
      save: 'Сохранить',
      deleteSection: 'Удалить раздел',
      deleteSectionTitle: 'Удалить «{name}»?',
      deleteSectionBody: {
        one: 'Раздел и его {count} файл будут удалены безвозвратно.',
        few: 'Раздел и его {count} файла будут удалены безвозвратно.',
        many: 'Раздел и его {count} файлов будут удалены безвозвратно.',
        other: 'Раздел и его {count} файла будут удалены безвозвратно.',
      },
      empty: 'Файлов пока нет. Перетащите фото и видео выше.',
      emptySection: 'В этом разделе пока нет файлов.',
      dropTitle: 'Перетащите сюда фото и видео',
      dropHint: 'Или нажмите, чтобы выбрать. Сотни файлов за раз: фото до 50 МБ, видео до 1 ГБ и 10 минут (MP4 или MOV, H.264).',
      uploading: 'Загрузка {done} из {total}',
      uploaded: 'Загружено {done} из {total}',
      notAccepted: {
        one: 'Не принят {count} файл',
        few: 'Не принято {count} файла',
        many: 'Не принято {count} файлов',
        other: 'Не принято {count} файла',
      },
      clearUploads: 'Очистить',
      processing: 'Обрабатываем...',
      processingFailed: 'Превью не создано',
      video: 'Видео',
      cover: 'Обложка',
      makeCover: 'Сделать обложкой',
      moveTo: 'Перенести в «{name}»',
      deleteFile: 'Удалить',
      deleteFileTitle: 'Удалить этот файл?',
      deleteFileBody: '«{name}» будет удалён безвозвратно вместе с отметкой выбора и комментариями.',
      fileActions: 'Действия с файлом',
      hidden: 'Скрыто гостем',
      restore: 'Вернуть гостям',
      restored: 'Гости снова его видят',
      dragHint: 'Перетаскивайте файлы, чтобы изменить порядок в разделе.',
    },
    uploadErrors: {
      FILE_TYPE: 'Не фото и не видео MP4/MOV',
      PHOTO_TOO_LARGE: 'Фото больше 50 МБ',
      VIDEO_TOO_LARGE: 'Видео больше 1 ГБ',
      GALLERY_VIDEO_TOO_LONG: 'Видео длиннее 10 минут',
      GALLERY_VIDEO_NOT_H264: 'Видео не в H.264 (на iPhone выберите «Наиболее совместимый»)',
      GALLERY_VIDEO_UNREADABLE: 'Не удалось прочитать видео',
      STORAGE_LIMIT_EXCEEDED: 'Хранилище заполнено',
      FAILED: 'Не удалось загрузить',
    },
    selection: {
      heading: 'Выбор гостей: {count}',
      headingWithLimit: 'Выбор гостей: {count} / {limit}',
      sentAt: 'Отправлено {date}',
      notSent: 'Ещё не отправлено: гости выбирают',
      copyNames: 'Скопировать имена файлов',
      namesCopied: 'Имена файлов скопированы: вставьте их в поиск Lightroom',
      unlock: 'Разблокировать выбор',
      unlocked: 'Выбор разблокирован: гости снова могут его менять',
      empty: 'Гости пока ничего не выбрали.',
      anonymous: 'без имени',
    },
    settings: {
      title: 'Настройки',
      titleLabel: 'Название',
      titlePlaceholder: 'Например, Елена и Максим',
      shootDateLabel: 'Дата съёмки',
      styles: {
        COVER: 'Обложка',
        EDITORIAL: 'Редакционный',
        COMPACT: 'Компактный',
      },
      layouts: {
        GRID: 'Сетка',
        MASONRY: 'Мозаика',
        SLIDESHOW: 'Слайдшоу',
      },
      access: 'Доступ',
      passwordLabel: 'Пароль',
      passwordPlaceholder: 'Без пароля',
      passwordInvalid: 'Пароль должен быть не короче 4 символов.',
      expiresLabel: 'Доступ до (необязательно)',
      expiresHint: 'После этой даты галерея скрывается, файлы остаются.',
      expiresClear: 'Убрать дату',
      expiryLockedHint: 'Входит в план Pro. Уже выбранные дата или удаление действуют и дальше, их можно убрать. Pro покупают в приложении Matcha, в разделе «Моя подписка».',
      autoDeleteLabel: 'Удалить файлы после срока',
      autoDelete: {
        OFF: 'Не удалять',
        NOW: 'Сразу после срока',
        AFTER_30_DAYS: 'Через 30 дней',
        AFTER_90_DAYS: 'Через 90 дней',
      },
      autoDeleteHint: 'Безвозвратно. За 7 дней придёт push: можно отменить или продлить.',
      autoDeleteNeedsExpiry: 'Сначала укажите дату доступа.',
      guests: 'Что могут гости',
      downloadsLabel: 'Скачивание',
      downloads: {
        ALL: 'Оригиналы и web-размер',
        WEB: 'Только web-размер (2048 px)',
        ORIGINAL: 'Только оригиналы',
        OFF: 'Выключено',
      },
      languageLabel: 'Язык галереи',
      languages: {
        SITE: 'Как на сайте',
        uk: 'Українська',
        en: 'English',
        ru: 'Русский',
      },
      languageHint: 'Кнопки, подсказки и экран пароля для гостей. Ваши названия и подписи остаются как есть.',
      guestHintsLabel: 'Подсказки для гостей',
      guestHintsSwitch: 'Показывать гостям подсказки',
      guestHintsHint: 'Короткие шаги, которые гости видят один раз на каждом устройстве после пароля: как выбирать, отправлять и скачивать.',
      allowHidingLabel: 'Скрытые фото',
      allowHidingSwitch: 'Гости могут скрывать фото',
      allowHidingHint: 'Гость может скрыть фото или видео для всех, у кого есть ссылка. Вы по-прежнему видите его здесь с пометкой и можете вернуть.',
      watermarkLabel: 'Водяной знак',
      watermarkSwitch: 'Показывать гостям мой водяной знак',
      watermarkHint: 'Гости видят и скачивают фото веб-размера с вашим водяным знаком. Видео и обложка остаются без него.',
      watermarkOriginalsHint: 'Оригиналы скачиваются без водяного знака.',
      watermarkEdit: 'Вид водяного знака',
      selectionLimitLabel: 'Лимит выбора (пусто — без лимита)',
      selectionLimitInvalid: 'Лимит выбора — целое число от 1.',
      done: 'Готово',
      saving: 'Сохраняем...',
      saved: 'Настройки сохранены',
      deleteGallery: 'Удалить галерею',
      deleteTitle: 'Удалить «{title}»?',
      deleteBody: {
        one: '{count} файл, выбор и комментарии будут удалены безвозвратно. Ссылка перестанет работать.',
        few: 'Все {count} файла, выбор и комментарии будут удалены безвозвратно. Ссылка перестанет работать.',
        many: 'Все {count} файлов, выбор и комментарии будут удалены безвозвратно. Ссылка перестанет работать.',
        other: 'Все {count} файла, выбор и комментарии будут удалены безвозвратно. Ссылка перестанет работать.',
      },
      deleteConfirm: 'Удалить',
      deleted: 'Галерея удалена',
    },
    errors: {
      actionFailed: 'Не удалось сохранить изменение. Попробуйте ещё раз.',
      GALLERY_PROVIDER_ONLY: 'Галереи могут быть только у профиля исполнителя.',
      GALLERY_LIMIT_REACHED: 'На вашем плане больше нет места для галерей. Удалите ненужную; в плане Pro ограничений нет.',
      GALLERY_TITLE_TOO_LONG: 'Название слишком длинное.',
      GALLERY_SHOOT_DATE_INVALID: 'Неверная дата съёмки.',
      GALLERY_SELECTION_LIMIT_INVALID: 'Лимит выбора — целое число от 1.',
      GALLERY_LAST_SECTION: 'В галерее остаётся хотя бы один раздел.',
      GALLERY_COVER_NOT_PHOTO: 'Обложкой может быть только фото.',
      GALLERY_PLAN_REQUIRED: 'Эта настройка входит в план Pro. Pro покупают в приложении Matcha, в разделе «Моя подписка».',
      GALLERY_WATERMARK_LOGO_REQUIRED: 'Сначала загрузите логотип PNG, а затем выберите его как водяной знак.',
      GALLERY_WATERMARK_TEXT_TOO_LONG: 'Текст водяного знака слишком длинный.',
    },
    watermark: {
      title: 'Водяной знак',
      locked: 'Водяной знак входит в план Pro. Здесь его можно посмотреть, а изменить — с планом Pro; Pro покупают в приложении Matcha.',
      loadFailed: 'Не удалось загрузить водяной знак.',
      preview: 'Предпросмотр водяного знака',
      previewHint: 'Примерно. Настоящий знак подбирается под размер каждого фото.',
      kindLabel: 'Знак',
      kinds: {
        TEXT: 'Текст',
        LOGO: 'Логотип',
      },
      textLabel: 'Текст',
      textPlaceholder: 'Ваше имя или студия',
      textHint: 'Оставьте пустым, чтобы показывать имя профиля.',
      logoLabel: 'Логотип',
      logoHint: 'Файл PNG до 5 МБ. Лучше всего смотрится прозрачный фон.',
      storedLogoHint: 'Логотип сохранён, но не используется. Удалите его, чтобы освободить место.',
      noLogo: 'Логотипа пока нет',
      chooseLogo: 'Выбрать PNG',
      replaceLogo: 'Заменить логотип',
      removeLogo: 'Удалить логотип',
      removeLogoTitle: 'Удалить логотип?',
      removeLogoBody: 'Файл будет удалён, а водяной знак снова станет текстом.',
      removeLogoConfirm: 'Удалить',
      uploading: 'Загрузка...',
      logoUploaded: 'Логотип добавлен',
      logoRemoved: 'Логотип удалён',
      logoErrors: {
        notPng: 'Логотип должен быть файлом PNG.',
        tooLarge: 'Логотип может быть до 5 МБ.',
        STORAGE_LIMIT_EXCEEDED: 'В хранилище не осталось места.',
        FAILED: 'Не удалось загрузить логотип. Попробуйте ещё раз.',
      },
      positionLabel: 'Расположение',
      positions: {
        CENTER: 'По центру',
        BOTTOM_RIGHT: 'В углу',
        TILED: 'Узором',
      },
      strengthLabel: 'Насыщенность',
      strengths: {
        LIGHT: 'Лёгкая',
        MEDIUM: 'Средняя',
        STRONG: 'Сильная',
      },
      appliesHint: 'Показывается на фото веб-размера в галереях, где включён водяной знак. Оригиналы, видео и обложка остаются без него.',
      saved: 'Водяной знак сохранён',
      done: 'Готово',
      saving: 'Сохранение...',
    },
    design: {
      open: 'Дизайн',
      back: 'Файлы',
      title: 'Дизайн',
      intro: 'Каждое изменение сохраняется сразу, и гости видят его тут же.',
      saving: 'Сохраняем...',
      coverLabel: 'Обложка',
      coverNone: 'Обложки пока нет',
      coverUploaded: 'Загруженная обложка',
      coverPicked: 'Фото из галереи',
      coverPreparing: 'Готовим обложку...',
      coverUpload: 'Загрузить JPG или PNG',
      coverUploading: 'Загрузка...',
      coverUploadedDone: 'Обложка загружена',
      coverPickLabel: 'Или выберите фото из галереи',
      coverPickItem: 'Сделать {name} обложкой',
      coverEmpty: 'Загрузите фото, чтобы выбрать из них обложку.',
      coverHint: 'Загруженная обложка не файл галереи: её нет в скачиваниях, и на ней никогда нет водяного знака.',
      coverErrors: {
        fileType: 'Обложкой может быть только фото JPG или PNG.',
        tooLarge: 'Обложка может быть до 50 МБ.',
        STORAGE_LIMIT_EXCEEDED: 'В вашем хранилище не хватает места.',
        FAILED: 'Не удалось загрузить обложку. Попробуйте ещё раз.',
      },
      styleLabel: 'Стиль страницы',
      layoutLabel: 'Раскладка фото',
      lookHint: 'Шрифты и цвета берутся из дизайна вашего сайта.',
      spacingLabel: 'Отступы между фото',
      spacings: {
        DESIGN: 'Как в дизайне',
        SMALLER: 'Меньше',
        LARGER: 'Больше',
        NONE: 'Без отступов',
      },
      shapeLabel: 'Форма фото',
      shapes: {
        SQUARE: 'Квадрат',
        ORIGINAL: 'Оригинальная',
        PORTRAIT: 'Вертикальная 4:5',
        LANDSCAPE: 'Горизонтальная 3:2',
      },
      watermarkProgress: 'Водяной знак: готово {ready}/{total}',
      watermarkFailed: 'Не удалось сделать: {count}',
      previewLabel: 'Предпросмотр',
      previewFrameTitle: 'Галерея так, как её видят гости',
      previewHint: 'Предпросмотр показывает сохранённую галерею и обновляется после каждого изменения.',
      desktop: 'Компьютер',
      phone: 'Телефон',
    },
    plan: {
      badge: 'Pro',
      lockedHint: 'Входит в план Pro. Pro покупают в приложении Matcha, в разделе «Моя подписка».',
    },
    cancel: 'Отмена',
  },
  reviewsPage: {
    navLabel: 'Отзывы',
    title: 'Отзывы',
    tabReports: 'Жалобы · {count}',
    tabAll: 'Все отзывы',
    tabHidden: 'Скрытые',
    starsLabel: 'Оценка',
    starsAll: 'Все оценки',
    starsOption: '{stars} ★',
    profileFilter: 'Профиль: {profile}',
    clearProfileFilter: 'Убрать фильтр по профилю',
    filterByProfile: 'Показать отзывы этого профиля',
    filtersUnavailableForReports: 'Фильтры действуют для вкладок «Все отзывы» и «Скрытые».',
    profileFallback: 'Непубличный профиль',
    columnProfile: 'Профиль',
    columnStars: '★',
    columnReview: 'Отзыв и ответ',
    columnChannel: 'Канал',
    columnReport: 'Жалоба',
    columnActions: 'Действия',
    replyLabel: 'Ответ: {reply}',
    replyNone: 'нет',
    channelLink: 'Ссылка для отзыва',
    channelEmail: 'Email-код',
    reportOpen: 'Открыта с {date}',
    reportRejected: 'Отклонена {date}',
    reportUpheld: 'Удовлетворена {date}',
    reportNone: '—',
    reportMessage: 'Примечание исполнителя: {message}',
    hiddenStatus: 'Скрыт: {reason}',
    hideAction: 'Скрыть',
    rejectReportAction: 'Отклонить жалобу',
    hideDialogTitle: 'Скрыть отзыв {author}?',
    hideDialogDescription: 'Отзыв исчезнет со всех страниц и из рейтинга. Исполнитель увидит причину.',
    reasonLabel: 'Причина',
    reasonSpam: 'Спам',
    reasonAbuse: 'Оскорбление',
    reasonFake: 'Фейк',
    reasonNotAboutProvider: 'Не об этом исполнителе',
    cancel: 'Отмена',
    loading: 'Загрузка отзывов...',
    loadFailed: 'Не удалось загрузить отзывы. Попробуйте ещё раз.',
    emptyReports: 'Открытых жалоб нет.',
    emptyReviews: 'Отзывы не найдены.',
    forbidden: 'Этот раздел доступен только модераторам Matcha.',
    hidden: 'Отзыв скрыт.',
    reportRejectedSuccess: 'Жалоба отклонена.',
    hideFailed: 'Не удалось скрыть отзыв. Попробуйте ещё раз.',
    rejectFailed: 'Не удалось отклонить жалобу. Попробуйте ещё раз.',
    loadMore: 'Показать ещё',
  },
  chatPage: {
    defaultGreeting:
      'Привет, я {assistantName} - AI-ассистент, который помогает планировать события и находить исполнителей услуг. Я могу помочь найти фотографа, ведущего мероприятия или другого исполнителя, а также конкретные услуги. Опишите, что вам нужно, например: "Нужен фотограф на свадьбу в пятницу в 18:00, город: {city}, бюджет до $500."',
    dynamicCapabilitiesIntro: 'С учётом доступных сейчас инструментов я могу помочь с',
    dynamicCapabilitiesFallback:
      'Я всё равно могу помочь спланировать событие простым языком и подсказать следующие шаги.',
    dynamicCapabilityEvents: 'планированием и обновлением событий',
    dynamicCapabilityPositions: 'созданием и управлением позициями',
    dynamicCapabilityProviders: 'поиском исполнителей и услуг',
    dynamicCapabilitySkills: 'подбором нужных навыков',
    dynamicCapabilitySummaries: 'сводками и статусами событий',
    sendError: 'Не удалось отправить сообщение.',
    fallbackAssistantReply:
      'Я не смог выполнить этот запрос. Переформулируйте его и попробуйте снова.',
    authRequiredHeading: 'Требуется аутентификация',
    authRequiredDescription: 'Войдите, чтобы получить доступ к чату.',
    authRequiredBanner: 'Чат доступен только аутентифицированным пользователям.',
    authAction: 'Войти / Зарегистрироваться',
    heading: 'Чат',
    subtitle: 'Общайтесь с {assistantName}, чтобы планировать события простым языком.',
    you: 'Вы',
    thinking: 'Думаю...',
    messageLabel: 'Сообщение',
    messagePlaceholder: 'Сообщение для {assistantName}...',
    composerHint: 'Enter для отправки, Shift+Enter для новой строки.',
    send: 'Отправить',
  },
  serviceDetailsPage: {
    missingTitle: 'Услуга не найдена',
    titleSuffix: 'Услуги Matcha Events',
    priceModeFrom: 'Цена от',
    priceModeRange: 'Диапазон цен',
    priceModeFixed: 'Фиксированная цена',
    backToServices: 'Назад к услугам',
    viewProfile: 'Открыть профиль',
    aboutProvider: 'Об этом исполнителе',
    providerDescriptionFallback: 'Этот исполнитель пока не добавил описание профиля.',
    moreServices: 'Другие услуги от {displayName}',
    browseAllServices: 'Смотреть все услуги',
  },
  profileDetailsPage: {
    storageUsageTemplate: 'Хранилище: {used} / {limit} ГБ',
    storageUsageUnlimitedTemplate: 'Хранилище: {used} ГБ',
    missingTitle: 'Профиль не найден',
    backToProfiles: 'Назад к профилям',
    servicesLabel: 'Услуги',
    typicalBudgetRange: 'Диапазон бюджета:',
    locations: 'Локации:',
    languages: 'Языки:',
    latestServices: 'Посмотрите мои последние услуги',
    showAllServices: 'Показать все услуги {fullName}',
    noServices: 'У этого профиля пока нет активных услуг.',
    viewService: 'Смотреть услугу',
    openService: 'Открыть услугу',
    moreServicesAvailable: 'ещё услуг доступно',
    contactPhone: 'Телефон',
    contactEmail: 'Email',
    contactOther: 'Другое',
    socialTwitter: 'Twitter/X',
    socialInstagram: 'Instagram',
    socialThreads: 'Threads',
    socialFacebook: 'Facebook',
    socialTikTok: 'TikTok',
    socialYouTube: 'YouTube',
    socialWebsite: 'Сайт',
    socialOther: 'Другое',
  },
  profileServicesPage: {
    missingTitle: 'Услуги профиля не найдены',
    title: 'Услуги {displayName}',
    description:
      'Просматривайте все активные услуги, которые предлагает {displayName} на Matcha Events.',
    heading: 'Услуги {displayName}',
    backToProfile: 'Назад к профилю',
    noServices: 'У этого профиля пока нет активных услуг.',
  },
  positionDetailsPage: {
    missingTitle: 'Позиция не найдена',
    titleSuffix: 'Позиции Matcha Events',
    badge: 'Доступная позиция',
  },
  subscriptionPage: {
    navLabel: 'Подписка',
    title: 'Моя подписка',
    loading: 'Загружаем подписку...',
    loadFailed: 'Не удалось загрузить подписку. Попробуйте ещё раз.',
    current: 'Ваша подписка',
    names: { free: 'Free', pro: 'Pro' },
    compare: {
      storage: { label: 'Хранилище', free: '1 ГБ', pro: '5 ГБ' },
      galleries: { label: 'Галереи для клиентов', free: 'до 3', pro: 'без лимита' },
      gallerySettings: { label: 'Водяной знак, срок доступа, лимит выбора', free: '—', pro: '✓' },
      webDownloads: { label: 'Скачивание web-размера', free: '—', pro: '✓' },
      matchaMark: { label: 'Галерея без отметки Matcha', free: '—', pro: '✓' },
      ownAssistant: { label: 'Свой ИИ-ассистент для сайта', free: '—', pro: '✓' },
    },
    getProTitle: 'Pro оформляют в приложении Matcha',
    getProBody: 'Откройте «Моя подписка» в приложении: первые 7 дней бесплатно, дальше ежемесячно. После оформления Pro работает и здесь.',
    appStore: 'App Store',
    googlePlay: 'Google Play',
    status: {
      trial: 'Бесплатная неделя до {{date}}',
      renews: 'Продлится {{date}}',
      ends: 'Отменено. Pro действует до {{date}}',
    },
    manage: {
      APP_STORE: 'Оформлено в App Store. Управлять или отменить можно на iPhone: Настройки → ваше имя → Подписки.',
      PLAY_STORE: 'Оформлено в Google Play. Управлять или отменить можно в Google Play → Платежи и подписки.',
      INTERNAL: 'Pro предоставлен командой Matcha.',
    },
  },
  sitePage: {
    navLabel: 'Мой сайт',
    title: 'Мой сайт',
    status: {
      create: 'Создать',
      draft: 'Черновик',
      published: 'Опубликован',
      disabled: 'Выключен',
    },
    publishedVersion: 'Опубликован · версия {version}',
    notPublished: 'Ещё не опубликован',
    disabledStatus: 'Выключен: посетители не видят сайт',
    open: 'Открыть',
    share: 'Поделиться',
    draft: {
      title: 'Есть неопубликованные изменения',
      message: 'Посетители видят предыдущую версию.',
      firstMessage: 'Посмотрите черновик и опубликуйте сайт.',
      preview: 'Посмотреть',
      publish: 'Опубликовать',
      published: 'Сайт опубликован',
      publishedMessage: 'Посетители уже видят новую версию.',
      discard: 'Отменить изменения',
      discarded: 'Изменения отменены',
      discardSheet: {
        title: 'Отменить изменения?',
        message: 'Черновик будет удалён, сайт останется таким, как опубликован.',
        confirm: 'Отменить изменения',
        keep: 'Оставить',
      },
    },
    changeDesign: 'Изменить дизайн',
    remainingEdits: 'Правок на сегодня: {count}',
    remainingBuilds: 'Созданий сайта на сегодня: {count}',
    versions: {
      title: 'Версии',
      version: 'Версия {number}',
      current: 'на сайте',
      restore: 'Вернуть',
      hint: '«Вернуть» кладёт версию в черновик. На сайт она попадёт, когда вы её опубликуете.',
      restored: 'Версия {number} возвращена в черновик',
      restoredMessage: 'Посмотрите черновик и опубликуйте, когда будете готовы.',
    },
    language: {
      title: 'Язык сайта',
      hint: 'Язык кнопок, разделов и подписей на сайте. Ваши тексты из профиля остаются как есть.',
      options: {
        uk: 'Українська',
        en: 'English',
        ru: 'Русский',
      },
    },
    disable: 'Выключить сайт',
    enable: 'Включить сайт',
    disableConfirmTitle: 'Выключить сайт?',
    disableConfirmMessage: 'Посетители перестанут его видеть. Включить можно в любой момент, версии останутся.',
    empty: {
      heading: 'Собственный сайт из вашего профиля',
      body: 'Опишите, каким видите сайт, и AI-дизайнер его сделает. Тексты, цены, фото и контакты берутся из профиля, поэтому сайт обновляется сам, когда вы меняете профиль.',
      examplesTitle: 'Например',
      examples: {
        example1: 'Тёмный и стильный, как ночной клуб, с неоновыми акцентами',
        example2: 'Светлый и нежный, для свадеб, много воздуха и фото',
        example3: 'Как сайт, который мне нравится (ссылка), но в моих цветах',
        example4: 'Яркий и смелый: крупные буквы, много цвета',
        example5: 'Минималистичный и строгий, как у дизайн-студии',
        example6: 'Тёплый и уютный, землистые цвета, ощущение ручной работы',
        example7: 'Как глянцевый журнал: крупные фото и красивые заголовки',
        example8: 'Ретро в стиле 70-х, тёплые цвета и округлые шрифты',
        example9: 'Современный и технологичный: тёмный фон, чёткие линии',
        example10: 'Романтичный, пастельные цвета, мягкие формы',
        example11: 'Премиальный: много пространства, тонкие линии, сдержанная палитра',
        example12: 'Игривый и весёлый, для детских праздников и вечеринок',
      },
      inputLabel: 'Каким должен быть сайт?',
      placeholder: 'Стиль, настроение, цвета. Можно дать ссылку на сайт, который нравится.',
      create: 'Создать сайт',
      hint: 'Занимает 2–3 минуты. Пришлём уведомление, когда будет готово.',
    },
    assistant: {
      title: 'Редактируйте сайт в своём Claude',
      body: 'Если у вас есть Claude, он может менять дизайн этого сайта. Эти правки не тратят дневной лимит.',
      connect: 'Подключить Claude',
      connected: '{client} подключён',
      lastUsed: 'Последняя правка {date}',
      neverUsed: 'Ещё не делал правок',
      disconnect: 'Отключить',
      disconnectConfirmTitle: 'Отключить {client}?',
      disconnectConfirmMessage: '{client} больше не сможет менять ваш сайт. Подключить снова можно в любой момент.',
      disconnected: '{client} отключён',
      disconnectClient: 'Отключить {client}',
      changeTitle: 'Меняйте дизайн в своём Claude',
      changeBody: 'Подключите Claude, которым уже пользуетесь: он изменит цвета, шрифты и блоки сайта. Ваши данные на сайте берутся из профиля.',
      locked: {
        title: 'Свой ИИ-ассистент',
        body: 'Меняйте сайт в разговоре со своим Claude или ChatGPT. Доступно в плане Pro.',
      },
      createWithClaude: 'Создать сайт с Claude',
      changeWithClaude: 'Изменить дизайн с Claude',
      prompt: {
        create: 'Создай мне сайт на Matcha. Посмотри мой профиль и предложи дизайн.',
        change: 'Измени дизайн моего сайта на Matcha ({site}). Сначала посмотри, какой он сейчас, и спроси, что изменить.',
      },
      create: {
        title: 'Создайте сайт в своём Claude',
        body: 'Подключите Claude, которым уже пользуетесь, и он сделает сайт из вашего профиля: услуги, цены, фото и контакты подтянутся сами.',
        steps: {
          connect: 'Подключите Claude и подтвердите здесь',
          create: 'Нажмите «Создать сайт с Claude» и отправьте готовый запрос',
          publish: 'Claude покажет превью, а опубликует, когда вы скажете',
        },
        note: 'Нужен свой Claude (claude.ai). Matcha за него не платит и ничего не списывает.',
      },
      request: {
        title: 'Разрешить {client} редактировать ваш сайт?',
        can: 'Менять дизайн черновика и публиковать его, когда вы попросите',
        cannot: 'Не сможет менять профиль, услуги, цены и фото или выключить сайт',
        note: 'Запрос из вашей ссылки «Подключить Claude». Если вы её не открывали, отклоните.',
        allow: 'Разрешить',
        deny: 'Отклонить',
        allowedTitle: '{client} подключён',
        allowedMessage: 'Возвращайтесь в {client} и попросите изменить сайт. Отключить можно на странице «Мой сайт».',
        deniedTitle: 'Отклонено',
        deniedMessage: '{client} не получил доступа к вашему сайту.',
        done: 'Готово',
        close: 'Закрыть',
        none: 'Этот запрос уже завершился.',
      },
    },
    chat: {
      title: 'Дизайнер сайта',
      subtitle: 'Меняет только дизайн',
      intro: 'Напишите, что изменить на сайте: цвета, шрифты, блоки, настроение. Можно дать ссылку на сайт-пример.',
      working: 'Дизайнер работает…',
      steps: {
        reading: 'Смотрю сайт и профиль',
        designing: 'Меняю дизайн',
        checking: 'Проверяю страницы',
      },
      closeHint: 'Можно закрыть страницу: пришлём уведомление в приложение.',
      previewDraft: 'Посмотреть черновик',
      placeholder: 'Что изменить на сайте?',
      waitingPlaceholder: 'Подождите, пока дизайнер закончит',
      inputLabel: 'Сообщение дизайнеру',
      send: 'Отправить',
      limitReached: 'На сегодня лимит исчерпан. Новые попытки появятся в полночь по Киеву.',
    },
    designs: {
      section: 'Дизайн',
      title: 'Готовые дизайны',
      startBody: 'Выберите готовый дизайн, и сайт будет готов за минуту. Тексты, цены, фото и контакты берутся из профиля, поэтому сайт обновляется сам, когда вы меняете профиль.',
      choose: 'Выбрать готовый дизайн',
      startCount: {
        one: '{count} дизайн. Сначала те, что для ваших категорий.',
        few: '{count} дизайна. Сначала те, что для ваших категорий.',
        many: '{count} дизайнов. Сначала те, что для ваших категорий.',
        other: '{count} дизайна. Сначала те, что для ваших категорий.',
      },
      aiTitle: 'Опишите сайт AI-дизайнеру',
      aiBody: 'Расскажите о стиле, настроении и цветах, и он сделает дизайн за 2–3 минуты.',
      aiAction: 'Описать свой сайт',
      rowCurrent: 'Текущий: {name} · всего {count}',
      rowCount: {
        one: '{count} дизайн на выбор',
        few: '{count} дизайна на выбор',
        many: '{count} дизайнов на выбор',
        other: '{count} дизайна на выбор',
      },
      versionSummary: 'Готовый дизайн «{name}»',
      all: 'Все',
      seeAll: 'Все {count} ›',
      hint: 'Нажмите на дизайн, чтобы увидеть его на своих данных.',
      otherGroups: 'Другие группы',
      current: 'Текущий',
      viewLabel: 'Показать дизайн на',
      viewDesktop: 'Компьютер',
      viewMobile: 'Телефон',
      groupsLabel: 'Группы дизайнов',
      tileLabel: 'Дизайн {name}',
      groups: {
        universal: 'Универсальные',
        'photo-video': 'Фото и видео',
        'hosts-shows': 'Ведущие и шоу',
        music: 'Музыка',
        'decor-floristry': 'Декор и флористика',
        'food-sweets': 'Кухня и сладкое',
        venues: 'Локации',
        'wedding-fashion': 'Свадебная мода',
        beauty: 'Красота',
        'tech-effects': 'Техника и эффекты',
        'ceremony-planning': 'Церемония и организация',
        transport: 'Транспорт',
        printing: 'Полиграфия',
      },
      universalDesign: 'Универсальный дизайн',
      tryOnMyData: 'Посмотреть на моих данных',
      apply: 'Применить',
      applyHint: 'Дизайн заменит черновик. Посетители увидят его, когда вы опубликуете сайт.',
      replace: {
        title: 'Заменить черновик?',
        message: 'В черновике есть неопубликованные изменения. Дизайн «{name}» заменит их.',
        versionsKept: 'Опубликованные версии останутся, и любую из них можно вернуть.',
        confirm: 'Заменить черновик',
      },
      applied: 'Дизайн «{name}» в черновике',
      loadFailed: 'Не удалось загрузить дизайны',
      retry: 'Попробовать снова',
      errors: {
        previewFailedTitle: 'Не удалось открыть просмотр',
        applyFailedTitle: 'Не удалось применить дизайн',
      },
    },
    errors: {
      loadFailedTitle: 'Не удалось загрузить сайт',
      sendFailedTitle: 'Не удалось отправить сообщение',
      publishFailedTitle: 'Не удалось опубликовать сайт',
      restoreFailedTitle: 'Не удалось вернуть версию',
      discardFailedTitle: 'Не удалось отменить изменения',
      disableFailedTitle: 'Не удалось изменить состояние сайта',
      languageFailedTitle: 'Не удалось изменить язык сайта',
      tryAgain: 'Попробуйте ещё раз.',
    },
    linkCopied: 'Ссылка скопирована',
    profileMissing: 'Профили не найдены. Сначала создайте профиль.',
    back: 'Назад',
    cancel: 'Отмена',
    or: 'или',
  },
};
